import { AppModal } from "@/components/ui/AppModal/AppModal";
import { CommunicationSlideoverForm } from "@/components/ui/CommunicationSlideover/CommunicationSlideoverForm";
import { FormLoadingOverlay } from "@/components/ui/Form/FormLoadingOverlay";
import React, { Suspense, useEffect, useState } from "react";

interface CommunicationSlideoverProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  selectedContactId: string;
  matterId?: string;
  defaultMessage?: string;
}

export const CommunicationSlideover = React.memo(
  ({
    open,
    setOpen,
    selectedContactId,
    matterId,
    defaultMessage,
  }: CommunicationSlideoverProps) => {
    const [isDirty, setIsDirty] = useState(false);

    useEffect(() => {
      if (!open) {
        setIsDirty(false);
      }
    }, [open]);

    return (
      <AppModal
        open={open}
        onOpenChange={setOpen}
        title="Communication"
        description="Send a text message to a contact"
        size="2xl"
        isDirty={isDirty}
        bodyContained
        overlayClassName="z-[108] bg-black/50 backdrop-blur-md"
        className="z-[109] h-[min(90vh,880px)] w-[calc(100vw-2rem)] max-w-4xl"
      >
        <div className="flex h-full min-h-0 w-full min-w-0 flex-1 flex-col overflow-hidden">
          <Suspense fallback={<FormLoadingOverlay />}>
            <CommunicationSlideoverForm
              selectedContactId={selectedContactId}
              matterId={matterId}
              defaultMessage={defaultMessage}
              onDirtyChange={setIsDirty}
            />
          </Suspense>
        </div>
      </AppModal>
    );
  },
);

CommunicationSlideover.displayName = "CommunicationSlideover";
